import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CookieService from 'services/CookieService'
import { updateUserRoutine, updateUserLocalRoutine } from 'features/auth/ducks/actions'
import { getCurrentUser } from 'features/auth/ducks/selectors'

const EVENT = 'bp:hide-duplicates-changed'

const useHideDuplicates = (bpId) => {
  const dispatch = useDispatch()
  const serverValue = useSelector((state) => getCurrentUser(state)?.hideDuplicateFiles)
  const [value, setValue] = useState(() =>
    serverValue !== undefined && serverValue !== null ? serverValue : CookieService.getHideDuplicates(bpId)
  )

  useEffect(() => {
    if (serverValue !== undefined && serverValue !== null) {
      setValue(serverValue)
      CookieService.setHideDuplicates(bpId, serverValue)
    }
    const handler = (e) => {
      if (e.detail?.bpId === bpId) setValue(e.detail.value)
    }
    window.addEventListener(EVENT, handler)
    return () => window.removeEventListener(EVENT, handler)
  }, [serverValue, bpId])

  const update = useCallback((next) => {
    CookieService.setHideDuplicates(bpId, next)
    setValue(next)
    window.dispatchEvent(new CustomEvent(EVENT, { detail: { bpId, value: next } }))
    dispatch(updateUserLocalRoutine({ hideDuplicateFiles: next }))
    dispatch(updateUserRoutine({ hide_duplicate_files: next }))
  }, [bpId, dispatch])

  return [value, update]
}

export default useHideDuplicates
